import { render, staticRenderFns } from "./NewProcess.vue?vue&type=template&id=01d1091c&scoped=true&lang=pug"
import script from "./NewProcess.vue?vue&type=script&lang=js"
export * from "./NewProcess.vue?vue&type=script&lang=js"
import style0 from "./NewProcess.vue?vue&type=style&index=0&id=01d1091c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1091c",
  null
  
)

export default component.exports